import { IPropStorage } from "./prop-storage-types";
import { debounce } from "df-helpers/dist/debounce"
const isBrowser = () => typeof window !== "undefined";

type IMap = {[id:string]:any};

export class LocalPropStorage implements IPropStorage {
	private _data: IMap = {};
	constructor(
		private name_space: string,
		private useSessionStorage?: boolean,
		private func_loaded?: (success: boolean, data: IMap) => void,
		private func_saved?: () => void,
	) {
		if (!this.name_space) this.name_space = "default";
		if (this.useSessionStorage == undefined) this.useSessionStorage = false;

		isBrowser() && this.load();
	}

	private getStorage(): Storage {
		return this.useSessionStorage ? window.sessionStorage : window.localStorage;
	}

	public setItem(name: string, value: any) {
		this._data[name] = value;
		this.save();
	}

	public getItem(name: string): any {
		return this._data[name];
	}

	public removeItem(name: string) {
		delete this._data[name];
		this.save();
	}

	public clear() {
		this._data = {};
		this.getStorage().removeItem(this.name_space);
	}

	public async load(): Promise<void> {
		const str = this.getStorage().getItem(this.name_space);
		try {
			this._data = JSON.parse(str || "") as any;
		} catch {}
		if (!this._data || typeof this._data !== "object" || Array.isArray(this._data))
			this._data = {};
		this.func_loaded?.(true, this._data);
	}

	private _save() {
		const str = JSON.stringify(this._data);
		this.getStorage().setItem(this.name_space, str);
		this.func_saved?.();
	}

	private _save_debounced = debounce(this._save.bind(this), 300);

	public async save(instant_save?: boolean): Promise<void> {
		if (!instant_save) this._save_debounced();
		else this._save();
	}

	public getKeys(): string[] {
		return Object.keys(this._data);
	}

	//if the properties have been downloaded and ready to be used
	public isLoaded(): boolean {
		return true;
	}
	//if the changes have been saved
	public isSaved(): boolean {
		return true;
	}
}

/** default local storage */
export const g_publicLocalStorage = new LocalPropStorage("public");
/** will be cleared when the user logout */
export const g_personalLocalStorage = new LocalPropStorage("personal");

/** default local storage */
export const g_publicSessionStorage = new LocalPropStorage("public", true);
/** will be cleared when the user logout */
export const g_personalSessionStorage = new LocalPropStorage("personal", true);
